export function checkPhone(str: string) {
    var numStr = str.replace(/(^\s*)|(\s*$)/g, "");
    var reg = /^(1)[3|4|5|6|7|8|9]\d{9}$/;
    return reg.test(numStr);
}

export function getQueryString(name: string) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return "";
}

export function getCookie(key: string) {
    return document.cookie.replace(new RegExp(`(?:(?:^|.*;\\s*)${key}\\s*\\=\\s*([^;]*).*$)|^.*$`), "$1");
}

export function getBaseUrl() {
    const host = window.location.host;
    const isDev = host.indexOf("localhost") >= 0 || host.indexOf("192.168") >= 0 || host.indexOf("iad.") >= 0 || host.indexOf("mobtest.my.jj.cn") >= 0;
    const url = isDev ? "https://mobtest.my.jj.cn/pxyiad/3036/hxzyy/" : "https://wzwd.jj.cn/";
    // console.log(isDev, host, url);
    return url;
}
